import Vue from 'vue'
import Router from 'vue-router'
import Call from './views/call.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    //{
    //  path: '/',
    //  name: 'call',
    //  component: Call
    //}, 
    {  //历史记录
      path: '/info',
      name: 'info',
      component: () => import('./views/info.vue')
    },
    {  //任务列表
      path: '/apply',
      name: 'apply',
      component: () => import('./views/apply.vue')
    },
    {  //登录
      path: '/', // login
      name: 'login',
      component: () => import('./views/login.vue')
    },
    {  //
      path: '/success',
      name: 'success',
      component: () => import('./views/success.vue')
    },
    {  //
      path: '/pay',
      name: 'pay',
      component: () => import('./views/pay.vue')
    },
    {  //
      path: '/view',
      name: 'view',
      component: () => import('./views/view.vue')
    },
    {  //
      path: '/link',
      name: 'link',
      component: () => import('./views/link.vue')
    }
  ]
})
